module.exports = __webpack_public_path__ + "assets/img/12-s.eba91ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/12-s.jpg
// module id = 1zbC
// module chunks = 0